import logging from 'utils/logging';
import {
  GAMESTATE_ROUND,
  GAMESTATE_ROUND_FINAL,
  GAMESTATE_ROUNDSTATE_QUESTION_WAGERING,
  SUBMISSION_STATE_WAGER,
} from '../../gamestate/constants';
import { advanceState } from '../../gamestate/GameState';
import { registerCacheReset } from '../momentCacheManager';

const log = logging.getLogger('moments.FinalAllWagersIn');
log.setLevel('info');

let triggered = false;

const resetTriggered = () => { triggered = false; };
registerCacheReset('round', resetTriggered);

/**
 * Trigger-only moment (no narration). Auto-advances to question.reading
 * when all players have submitted their wagers.
 */
export const FinalAllWagersInTrigger = {
  id: 'FINAL_ALL_WAGERS_IN',
  shouldTrigger: ({ currentState, currentPlayers, submissions }) => {
    if (triggered) return false;

    if (currentState?.currentState !== GAMESTATE_ROUND) return false;
    if (currentState?.round !== GAMESTATE_ROUND_FINAL) return false;
    if (currentState?.roundState !== GAMESTATE_ROUNDSTATE_QUESTION_WAGERING) return false;

    if (!currentPlayers || currentPlayers.length === 0) return false;
    if (!submissions || submissions.length === 0) return false;

    // Check if all players have submitted a wager (status === 'wager' means wager is in)
    const allWagered = submissions.every(ps => {
      if (!ps.submission) return false;
      return ps.submission.status === SUBMISSION_STATE_WAGER;
    });

    // Also check we have submissions for all players
    const allPlayersHaveSubmission = currentPlayers.every(player =>
      submissions.some(ps => ps.id === player.id && ps.submission)
    );

    if (allWagered && allPlayersHaveSubmission) {
      triggered = true;
      log.info('All wagers are in, auto-advancing to question reading');

      return {
        shouldTriggerAction: true,
        shouldGenerateNarration: false,
        triggerAction: FinalAllWagersInTrigger.triggerAction,
      };
    }

    return false;
  },

  triggerAction: async (gameObject, players, dispatch) => {
    log.info('All wagers in, advancing state');
    try {
      await advanceState(gameObject, players, dispatch);
    } catch (error) {
      log.error('Error advancing after all wagers in:', error);
    }
  },
};

// No playback - this is a trigger-only moment
export const FinalAllWagersInPlayback = {
  id: 'FINAL_ALL_WAGERS_IN_PLAYBACK',
  momentType: null,
  shouldPlay: () => false,
};

const api = {
  trigger: FinalAllWagersInTrigger,
  playback: FinalAllWagersInPlayback,
};

export default api;
